module.exports = __webpack_public_path__ + "static/media/banner-image-lg.835c00b3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/banner-image-lg.jpeg
// module id = 1396
// module chunks = 1